import { FormattedMessage } from "react-intl";

export const paginationOptions = ({ locale }) => {
  return {
    rowsPerPageText: <FormattedMessage id={"rows_per_page"} />,
    rangeSeparatorText: locale === "en" ? "of" : "de",
    noRowsPerPage: false,
    selectAllRowsItem: false,
    selectAllRowsItemText: <FormattedMessage id={"all"} />,
  };
};